/**
 * Formats a given string to lowercase or uppercase based on the provided option.
 *
 * @param input - The string to be formatted.
 * @param toUpperCase - Optional boolean indicating if the string should be converted to uppercase. Default is false (lowercase).
 * @returns The formatted string in either lowercase or uppercase.
 */
export default function formatString(input, toUpperCase = false) {
    return toUpperCase ? input.toUpperCase() : input.toLowerCase();
}
export function getAvatarInitials(name) {
    const nameParts = name.trim().split(/\s+/).filter(Boolean);
    if (nameParts.length === 0)
        return '';
    if (nameParts.length === 1)
        return nameParts[0].charAt(0).toUpperCase();
    const firstInitial = nameParts[0].charAt(0);
    const lastInitial = nameParts[nameParts.length - 1].charAt(0);
    return (firstInitial + lastInitial).toUpperCase();
}
